module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Code/Github-fedb3acf5d12bde4423cf2e6b32b1872.svg";